/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistryInfo } from './RegistryInfo'
import {
  RegistryInfoFromJSON,
  RegistryInfoFromJSONTyped,
  RegistryInfoToJSON,
} from './RegistryInfo'

/**
 *
 * @export
 * @interface GetTrademarkRequestInfo200Response
 */
export interface GetTrademarkRequestInfo200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetTrademarkRequestInfo200Response
   */
  status: boolean
  /**
   *
   * @type {RegistryInfo}
   * @memberof GetTrademarkRequestInfo200Response
   */
  data: RegistryInfo
}

/**
 * Check if a given object implements the GetTrademarkRequestInfo200Response interface.
 */
export function instanceOfGetTrademarkRequestInfo200Response(
  value: object
): value is GetTrademarkRequestInfo200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetTrademarkRequestInfo200ResponseFromJSON(
  json: any
): GetTrademarkRequestInfo200Response {
  return GetTrademarkRequestInfo200ResponseFromJSONTyped(json, false)
}

export function GetTrademarkRequestInfo200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetTrademarkRequestInfo200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: RegistryInfoFromJSON(json['data']),
  }
}

export function GetTrademarkRequestInfo200ResponseToJSON(
  value?: GetTrademarkRequestInfo200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: RegistryInfoToJSON(value['data']),
  }
}
